import Vue from 'vue';
export const AZEventBus = new Vue();